<template>
  <div class="download-btn-container" :style="btImgStyle" @click="toApp"></div>
</template>
<script>
import { BsToApp } from 'dida-web-common'

export default {
    name: 'DownloadBtn',
    props: {
        editableData: {
            type: Object,
            default: function() {
                return {
                    basic: {}
                }
            }
        },
        isEditing: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            btImg: '',
            guideImg: '',
            imgUrl: '', // 向外抛出的下载按钮图片链接
        }
    },
    computed: {
        basicConf: function() {
            return this.editableData.basic
        },
        getBtImg: function() {
            return this.btImg || this.basicConf.btImg
        },
        getGuideImg: function() {
            return this.guideImg || this.basicConf.guideImg
        },
        btImgStyle: function() {
            return {
                'background-image': `url(${this.getBtImg})`,
                'background-repeat': 'no-repeat',
                'background-size': '100% auto',
            }
        }
    },
    mounted() {
        // 判断是否进入页面就调用   urlSchemeParams: `didapinche://order?rid=666666666&role=2&invite_from_type=2&type=75`
        if (this.basicConf.noNeedClick) {
            BsToApp.vnToApp({
                isToDownLoad: this.basicConf.isToDownLoad, // 安卓环境是否先进入下载页面，默认不进入
                isFromHermes: true,
                maskImg: this.getGuideImg,
                urlSchemeParams: this.basicConf.schemeUrl,
                setPageBg: this.setPageBg.bind(this),
                uLTargetUrl: this.basicConf.uLTargetUrl || window.location.href,
            })
        }
    },
    methods: {
        // 点击按钮调用
        toApp() {
            BsToApp.vnToApp({
                isToDownLoad: this.basicConf.isToDownLoad ? true : false, // 安卓环境是否先进入下载页面，默认不进入
                isFromHermes: true,
                isClick: true,
                maskImg: this.getGuideImg,
                urlSchemeParams: this.basicConf.schemeUrl,
                uLTargetUrl: this.basicConf.uLTargetUrl || window.location.href,
            })
        },
        setPageBg(params) {
            this.$bus.$emit('setPagebg', { image: params.bgPic, imageType: 'image' })
            this.imgUrl = params.buttonIconUrl
            this.$emit('dispatchEvent', 'btnImg')
        }
    }
}
</script>

<style lang="scss" scoped>
    .download-btn-container {
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>
